// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { getAuthProviderById } from 'app/constants/enums/AuthProvider/main';

/* eslint-disable max-len */
export const DMM = getAuthProviderById('dmm');
export const DMM_STAGING = getAuthProviderById('dmm_staging');
export const DMM_TEST = getAuthProviderById('dmm_test');
export const FACEBOOK = getAuthProviderById('facebook');
export const PASSWORD = getAuthProviderById('password');
/* eslint-enable max-len */
